const userSearchLimits = {
    MAX_FICTITIOUS_SEARCH: 1000,
    MAX_NOT_FICTITIOUS_SEARCH: 100
}

export default userSearchLimits